import React, { useContext } from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import { Context as NavigationContext } from '@swf/components/StarsWizard/components/Navigation/Navigation';
import BackArrow from '@swf/first/assets/icons/back-arrow.svg';

import type { Buttons } from '../../Header';

import { TXTCLI_Back } from './NavigationHeader.messages.json';
import { container, headerSecondary, wrapper } from './NavigationHeader.scss';

interface Props {
  buttons?: Buttons;
  backButtonDisabled: boolean;
  handleBackClick: () => void;
}

const NavigationHeader: React.FC<Props> = ({ buttons, backButtonDisabled, handleBackClick }) => {
  const { previous } = useContext(NavigationContext);
  return (
    <div className={container} data-testid="navigation-header">
      <div className={headerSecondary}>
        <div className={wrapper}>
          {(buttons?.back || (!buttons && previous)) && (
            <StarsButton
              icon={<BackArrow />}
              disabled={backButtonDisabled}
              onClick={handleBackClick}
              translation={TXTCLI_Back}
              variant="text"
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default NavigationHeader;
